import React from "react";
import { Chart } from "react-google-charts";


class CustSource extends React.Component {
	constructor(props) {
	    super(props);
	}

	render() {
		return (
			<p>Inside CustSource Chart</p>
		)
	}
}

export default (CustSource);


// WEBPACK FOOTER //
// ./src/views/Audiences/CustSource.jsx